// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "dashboard/v1/dashboard.proto" (package "dashboard.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal APIs for the n-machines dashboard service
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message dashboard.v1.CreateDashboardRequest
 */
export interface CreateDashboardRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message dashboard.v1.CreateDashboardResponse
 */
export interface CreateDashboardResponse {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
}
/**
 * @generated from protobuf message dashboard.v1.GetDashboardRequest
 */
export interface GetDashboardRequest {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
}
/**
 * @generated from protobuf message dashboard.v1.GetDashboardResponse
 */
export interface GetDashboardResponse {
    /**
     * @generated from protobuf field: dashboard.v1.Dashboard dashboard = 1;
     */
    dashboard?: Dashboard;
}
/**
 * @generated from protobuf message dashboard.v1.ListDashboardsRequest
 */
export interface ListDashboardsRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message dashboard.v1.ListDashboardsSummary
 */
export interface ListDashboardsSummary {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 4;
     */
    lastUpdatedAt?: Timestamp;
}
/**
 * @generated from protobuf message dashboard.v1.ListDashboardsResponse
 */
export interface ListDashboardsResponse {
    /**
     * sorted by oldest created dashboard -> most recently created dashboard
     *
     * @generated from protobuf field: repeated dashboard.v1.ListDashboardsSummary dashboards = 1;
     */
    dashboards: ListDashboardsSummary[];
}
/**
 * @generated from protobuf message dashboard.v1.DuplicateDashboardRequest
 */
export interface DuplicateDashboardRequest {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
}
/**
 * @generated from protobuf message dashboard.v1.DuplicateDashboardResponse
 */
export interface DuplicateDashboardResponse {
    /**
     * @generated from protobuf field: string new_dashboard_id = 1;
     */
    newDashboardId: string;
}
/**
 * @generated from protobuf message dashboard.v1.DeleteDashboardRequest
 */
export interface DeleteDashboardRequest {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
}
/**
 * @generated from protobuf message dashboard.v1.DeleteDashboardResponse
 */
export interface DeleteDashboardResponse {
}
/**
 * @generated from protobuf message dashboard.v1.UpdateDashboardLayoutRequest
 */
export interface UpdateDashboardLayoutRequest {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
    /**
     * @generated from protobuf field: dashboard.v1.DashboardNode new_layout_root = 2;
     */
    newLayoutRoot?: DashboardNode;
}
/**
 * @generated from protobuf message dashboard.v1.UpdateDashboardLayoutResponse
 */
export interface UpdateDashboardLayoutResponse {
}
/**
 * @generated from protobuf message dashboard.v1.UpdateDashboardNameRequest
 */
export interface UpdateDashboardNameRequest {
    /**
     * @generated from protobuf field: string dashboard_id = 1;
     */
    dashboardId: string;
    /**
     * @generated from protobuf field: string new_name = 2;
     */
    newName: string;
}
/**
 * @generated from protobuf message dashboard.v1.UpdateDashboardNameResponse
 */
export interface UpdateDashboardNameResponse {
}
/**
 * @generated from protobuf message dashboard.v1.SplitNode
 */
export interface SplitNode {
    /**
     * @generated from protobuf field: dashboard.v1.SplitDirection direction = 1;
     */
    direction: SplitDirection;
    /**
     * In the non-inclusive range (0, 1). Missing indicates 0.5 (or 50%) split.
     *
     * @generated from protobuf field: double split_percentage = 2;
     */
    splitPercentage: number;
    /**
     * @generated from protobuf field: dashboard.v1.DashboardNode first = 3;
     */
    first?: DashboardNode;
    /**
     * @generated from protobuf field: dashboard.v1.DashboardNode second = 4;
     */
    second?: DashboardNode;
}
/**
 * @generated from protobuf message dashboard.v1.MethodNone
 */
export interface MethodNone {
}
/**
 * @generated from protobuf message dashboard.v1.MethodCount
 */
export interface MethodCount {
}
/**
 * @generated from protobuf message dashboard.v1.MethodAvg
 */
export interface MethodAvg {
}
/**
 * @generated from protobuf message dashboard.v1.MethodMin
 */
export interface MethodMin {
}
/**
 * @generated from protobuf message dashboard.v1.MethodMax
 */
export interface MethodMax {
}
/**
 * @generated from protobuf message dashboard.v1.MethodSum
 */
export interface MethodSum {
}
/**
 * @generated from protobuf message dashboard.v1.MethodCustomQuery
 */
export interface MethodCustomQuery {
    /**
     * @generated from protobuf field: repeated string stages = 1;
     */
    stages: string[];
}
/**
 * @generated from protobuf message dashboard.v1.WindowMethod
 */
export interface WindowMethod {
    /**
     * @generated from protobuf field: double duration_s = 1;
     */
    durationS: number;
    /**
     * @generated from protobuf field: string path = 2;
     */
    path: string;
    /**
     * @generated from protobuf oneof: method
     */
    method: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: dashboard.v1.MethodNone none = 3;
         */
        none: MethodNone;
    } | {
        oneofKind: "count";
        /**
         * @generated from protobuf field: dashboard.v1.MethodCount count = 4;
         */
        count: MethodCount;
    } | {
        oneofKind: "average";
        /**
         * @generated from protobuf field: dashboard.v1.MethodAvg average = 5;
         */
        average: MethodAvg;
    } | {
        oneofKind: "min";
        /**
         * @generated from protobuf field: dashboard.v1.MethodMin min = 6;
         */
        min: MethodMin;
    } | {
        oneofKind: "max";
        /**
         * @generated from protobuf field: dashboard.v1.MethodMax max = 7;
         */
        max: MethodMax;
    } | {
        oneofKind: "sum";
        /**
         * @generated from protobuf field: dashboard.v1.MethodSum sum = 8;
         */
        sum: MethodSum;
    } | {
        oneofKind: "customQuery";
        /**
         * @generated from protobuf field: dashboard.v1.MethodCustomQuery custom_query = 9;
         */
        customQuery: MethodCustomQuery;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message dashboard.v1.AggregationMethod
 */
export interface AggregationMethod {
    /**
     * @generated from protobuf oneof: method
     */
    method: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: dashboard.v1.MethodNone none = 2;
         */
        none: MethodNone;
    } | {
        oneofKind: "count";
        /**
         * @generated from protobuf field: dashboard.v1.MethodCount count = 3;
         */
        count: MethodCount;
    } | {
        oneofKind: "average";
        /**
         * @generated from protobuf field: dashboard.v1.MethodAvg average = 4;
         */
        average: MethodAvg;
    } | {
        oneofKind: "min";
        /**
         * @generated from protobuf field: dashboard.v1.MethodMin min = 5;
         */
        min: MethodMin;
    } | {
        oneofKind: "max";
        /**
         * @generated from protobuf field: dashboard.v1.MethodMax max = 6;
         */
        max: MethodMax;
    } | {
        oneofKind: "sum";
        /**
         * @generated from protobuf field: dashboard.v1.MethodSum sum = 7;
         */
        sum: MethodSum;
    } | {
        oneofKind: "customQuery";
        /**
         * @generated from protobuf field: dashboard.v1.MethodCustomQuery custom_query = 8;
         */
        customQuery: MethodCustomQuery;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message dashboard.v1.StatNode
 */
export interface StatNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 3;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: string units = 4;
     */
    units: string;
    /**
     * @generated from protobuf field: string capture_method = 5;
     */
    captureMethod: string;
    /**
     * @generated from protobuf field: dashboard.v1.WindowMethod window = 6;
     */
    window?: WindowMethod;
    /**
     * @generated from protobuf field: dashboard.v1.AggregationMethod aggregation = 7;
     */
    aggregation?: AggregationMethod;
}
/**
 * @generated from protobuf message dashboard.v1.TimeSeriesNode
 */
export interface TimeSeriesNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 2;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: optional double y_axis_min = 3;
     */
    yAxisMin?: number;
    /**
     * @generated from protobuf field: optional double y_axis_max = 4;
     */
    yAxisMax?: number;
    /**
     * @generated from protobuf field: repeated dashboard.v1.TimeSeriesLine lines = 5;
     */
    lines: TimeSeriesLine[];
}
/**
 * @generated from protobuf message dashboard.v1.TimeSeriesLine
 */
export interface TimeSeriesLine {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string units = 2;
     */
    units: string;
    /**
     * @generated from protobuf field: string resource_name = 3;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string capture_method = 4;
     */
    captureMethod: string;
    /**
     * @generated from protobuf field: dashboard.v1.WindowMethod window = 5;
     */
    window?: WindowMethod;
    /**
     * @generated from protobuf field: dashboard.v1.AggregationMethod aggregation = 6;
     */
    aggregation?: AggregationMethod;
}
/**
 * @generated from protobuf message dashboard.v1.GPSNode
 */
export interface GPSNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string movement_sensor_name = 2;
     */
    movementSensorName: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 3;
     */
    refetchIntervalS: number;
}
/**
 * @generated from protobuf message dashboard.v1.TableNodeColumn
 */
export interface TableNodeColumn {
    /**
     * If not specified, the heading is the window method path.
     *
     * @generated from protobuf field: optional string heading = 1;
     */
    heading?: string;
    /**
     * @generated from protobuf field: string units = 2;
     */
    units: string;
    /**
     * @generated from protobuf field: optional dashboard.v1.WindowMethod window = 3;
     */
    window?: WindowMethod;
    /**
     * @generated from protobuf field: optional dashboard.v1.AggregationMethod aggregation = 4;
     */
    aggregation?: AggregationMethod;
}
/**
 * @generated from protobuf message dashboard.v1.TableNodeColumns
 */
export interface TableNodeColumns {
    /**
     * @generated from protobuf field: repeated dashboard.v1.TableNodeColumn columns = 1;
     */
    columns: TableNodeColumn[];
}
/**
 * @generated from protobuf message dashboard.v1.TableNode
 */
export interface TableNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 3;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: string capture_method = 4;
     */
    captureMethod: string;
    /**
     * @generated from protobuf oneof: display_method
     */
    displayMethod: {
        oneofKind: "columns";
        /**
         * @generated from protobuf field: dashboard.v1.TableNodeColumns columns = 5;
         */
        columns: TableNodeColumns;
    } | {
        oneofKind: "customQuery";
        /**
         * @generated from protobuf field: dashboard.v1.MethodCustomQuery custom_query = 6;
         */
        customQuery: MethodCustomQuery;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message dashboard.v1.DashboardNode
 */
export interface DashboardNode {
    /**
     * @generated from protobuf field: string node_id = 1;
     */
    nodeId: string;
    /**
     * @generated from protobuf oneof: node
     */
    node: {
        oneofKind: "split";
        /**
         * @generated from protobuf field: dashboard.v1.SplitNode split = 2;
         */
        split: SplitNode;
    } | {
        oneofKind: "stat";
        /**
         * @generated from protobuf field: dashboard.v1.StatNode stat = 3;
         */
        stat: StatNode;
    } | {
        oneofKind: "timeSeries";
        /**
         * @generated from protobuf field: dashboard.v1.TimeSeriesNode time_series = 4;
         */
        timeSeries: TimeSeriesNode;
    } | {
        oneofKind: "gps";
        /**
         * @generated from protobuf field: dashboard.v1.GPSNode gps = 5;
         */
        gps: GPSNode;
    } | {
        oneofKind: "table";
        /**
         * @generated from protobuf field: dashboard.v1.TableNode table = 6;
         */
        table: TableNode;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message dashboard.v1.Dashboard
 */
export interface Dashboard {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string org_id = 3;
     */
    orgId: string;
    /**
     * @generated from protobuf field: optional dashboard.v1.DashboardNode layout_root = 4;
     */
    layoutRoot?: DashboardNode;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 6;
     */
    lastUpdatedAt?: Timestamp;
}
/**
 * @generated from protobuf enum dashboard.v1.SplitDirection
 */
export enum SplitDirection {
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_COLUMN = 1;
     */
    COLUMN = 1,
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_ROW = 2;
     */
    ROW = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateDashboardRequest$Type extends MessageType<CreateDashboardRequest> {
    constructor() {
        super("dashboard.v1.CreateDashboardRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.CreateDashboardRequest
 */
export const CreateDashboardRequest = new CreateDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDashboardResponse$Type extends MessageType<CreateDashboardResponse> {
    constructor() {
        super("dashboard.v1.CreateDashboardResponse", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.CreateDashboardResponse
 */
export const CreateDashboardResponse = new CreateDashboardResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardRequest$Type extends MessageType<GetDashboardRequest> {
    constructor() {
        super("dashboard.v1.GetDashboardRequest", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.GetDashboardRequest
 */
export const GetDashboardRequest = new GetDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardResponse$Type extends MessageType<GetDashboardResponse> {
    constructor() {
        super("dashboard.v1.GetDashboardResponse", [
            { no: 1, name: "dashboard", kind: "message", T: () => Dashboard }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.GetDashboardResponse
 */
export const GetDashboardResponse = new GetDashboardResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDashboardsRequest$Type extends MessageType<ListDashboardsRequest> {
    constructor() {
        super("dashboard.v1.ListDashboardsRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.ListDashboardsRequest
 */
export const ListDashboardsRequest = new ListDashboardsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDashboardsSummary$Type extends MessageType<ListDashboardsSummary> {
    constructor() {
        super("dashboard.v1.ListDashboardsSummary", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.ListDashboardsSummary
 */
export const ListDashboardsSummary = new ListDashboardsSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDashboardsResponse$Type extends MessageType<ListDashboardsResponse> {
    constructor() {
        super("dashboard.v1.ListDashboardsResponse", [
            { no: 1, name: "dashboards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListDashboardsSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.ListDashboardsResponse
 */
export const ListDashboardsResponse = new ListDashboardsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateDashboardRequest$Type extends MessageType<DuplicateDashboardRequest> {
    constructor() {
        super("dashboard.v1.DuplicateDashboardRequest", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.DuplicateDashboardRequest
 */
export const DuplicateDashboardRequest = new DuplicateDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateDashboardResponse$Type extends MessageType<DuplicateDashboardResponse> {
    constructor() {
        super("dashboard.v1.DuplicateDashboardResponse", [
            { no: 1, name: "new_dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.DuplicateDashboardResponse
 */
export const DuplicateDashboardResponse = new DuplicateDashboardResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDashboardRequest$Type extends MessageType<DeleteDashboardRequest> {
    constructor() {
        super("dashboard.v1.DeleteDashboardRequest", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.DeleteDashboardRequest
 */
export const DeleteDashboardRequest = new DeleteDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDashboardResponse$Type extends MessageType<DeleteDashboardResponse> {
    constructor() {
        super("dashboard.v1.DeleteDashboardResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.DeleteDashboardResponse
 */
export const DeleteDashboardResponse = new DeleteDashboardResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDashboardLayoutRequest$Type extends MessageType<UpdateDashboardLayoutRequest> {
    constructor() {
        super("dashboard.v1.UpdateDashboardLayoutRequest", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_layout_root", kind: "message", T: () => DashboardNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.UpdateDashboardLayoutRequest
 */
export const UpdateDashboardLayoutRequest = new UpdateDashboardLayoutRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDashboardLayoutResponse$Type extends MessageType<UpdateDashboardLayoutResponse> {
    constructor() {
        super("dashboard.v1.UpdateDashboardLayoutResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.UpdateDashboardLayoutResponse
 */
export const UpdateDashboardLayoutResponse = new UpdateDashboardLayoutResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDashboardNameRequest$Type extends MessageType<UpdateDashboardNameRequest> {
    constructor() {
        super("dashboard.v1.UpdateDashboardNameRequest", [
            { no: 1, name: "dashboard_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.UpdateDashboardNameRequest
 */
export const UpdateDashboardNameRequest = new UpdateDashboardNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDashboardNameResponse$Type extends MessageType<UpdateDashboardNameResponse> {
    constructor() {
        super("dashboard.v1.UpdateDashboardNameResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.UpdateDashboardNameResponse
 */
export const UpdateDashboardNameResponse = new UpdateDashboardNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SplitNode$Type extends MessageType<SplitNode> {
    constructor() {
        super("dashboard.v1.SplitNode", [
            { no: 1, name: "direction", kind: "enum", T: () => ["dashboard.v1.SplitDirection", SplitDirection, "SPLIT_DIRECTION_"] },
            { no: 2, name: "split_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "first", kind: "message", T: () => DashboardNode },
            { no: 4, name: "second", kind: "message", T: () => DashboardNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.SplitNode
 */
export const SplitNode = new SplitNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodNone$Type extends MessageType<MethodNone> {
    constructor() {
        super("dashboard.v1.MethodNone", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodNone
 */
export const MethodNone = new MethodNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodCount$Type extends MessageType<MethodCount> {
    constructor() {
        super("dashboard.v1.MethodCount", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodCount
 */
export const MethodCount = new MethodCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodAvg$Type extends MessageType<MethodAvg> {
    constructor() {
        super("dashboard.v1.MethodAvg", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodAvg
 */
export const MethodAvg = new MethodAvg$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodMin$Type extends MessageType<MethodMin> {
    constructor() {
        super("dashboard.v1.MethodMin", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodMin
 */
export const MethodMin = new MethodMin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodMax$Type extends MessageType<MethodMax> {
    constructor() {
        super("dashboard.v1.MethodMax", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodMax
 */
export const MethodMax = new MethodMax$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodSum$Type extends MessageType<MethodSum> {
    constructor() {
        super("dashboard.v1.MethodSum", []);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodSum
 */
export const MethodSum = new MethodSum$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodCustomQuery$Type extends MessageType<MethodCustomQuery> {
    constructor() {
        super("dashboard.v1.MethodCustomQuery", [
            { no: 1, name: "stages", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.MethodCustomQuery
 */
export const MethodCustomQuery = new MethodCustomQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WindowMethod$Type extends MessageType<WindowMethod> {
    constructor() {
        super("dashboard.v1.WindowMethod", [
            { no: 1, name: "duration_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "none", kind: "message", oneof: "method", T: () => MethodNone },
            { no: 4, name: "count", kind: "message", oneof: "method", T: () => MethodCount },
            { no: 5, name: "average", kind: "message", oneof: "method", T: () => MethodAvg },
            { no: 6, name: "min", kind: "message", oneof: "method", T: () => MethodMin },
            { no: 7, name: "max", kind: "message", oneof: "method", T: () => MethodMax },
            { no: 8, name: "sum", kind: "message", oneof: "method", T: () => MethodSum },
            { no: 9, name: "custom_query", kind: "message", oneof: "method", T: () => MethodCustomQuery }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.WindowMethod
 */
export const WindowMethod = new WindowMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AggregationMethod$Type extends MessageType<AggregationMethod> {
    constructor() {
        super("dashboard.v1.AggregationMethod", [
            { no: 2, name: "none", kind: "message", oneof: "method", T: () => MethodNone },
            { no: 3, name: "count", kind: "message", oneof: "method", T: () => MethodCount },
            { no: 4, name: "average", kind: "message", oneof: "method", T: () => MethodAvg },
            { no: 5, name: "min", kind: "message", oneof: "method", T: () => MethodMin },
            { no: 6, name: "max", kind: "message", oneof: "method", T: () => MethodMax },
            { no: 7, name: "sum", kind: "message", oneof: "method", T: () => MethodSum },
            { no: 8, name: "custom_query", kind: "message", oneof: "method", T: () => MethodCustomQuery }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.AggregationMethod
 */
export const AggregationMethod = new AggregationMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatNode$Type extends MessageType<StatNode> {
    constructor() {
        super("dashboard.v1.StatNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "units", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "capture_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "window", kind: "message", T: () => WindowMethod },
            { no: 7, name: "aggregation", kind: "message", T: () => AggregationMethod }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.StatNode
 */
export const StatNode = new StatNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesNode$Type extends MessageType<TimeSeriesNode> {
    constructor() {
        super("dashboard.v1.TimeSeriesNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "y_axis_min", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "y_axis_max", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeSeriesLine }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.TimeSeriesNode
 */
export const TimeSeriesNode = new TimeSeriesNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesLine$Type extends MessageType<TimeSeriesLine> {
    constructor() {
        super("dashboard.v1.TimeSeriesLine", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "units", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "capture_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "window", kind: "message", T: () => WindowMethod },
            { no: 6, name: "aggregation", kind: "message", T: () => AggregationMethod }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.TimeSeriesLine
 */
export const TimeSeriesLine = new TimeSeriesLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GPSNode$Type extends MessageType<GPSNode> {
    constructor() {
        super("dashboard.v1.GPSNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "movement_sensor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.GPSNode
 */
export const GPSNode = new GPSNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TableNodeColumn$Type extends MessageType<TableNodeColumn> {
    constructor() {
        super("dashboard.v1.TableNodeColumn", [
            { no: 1, name: "heading", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "units", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "window", kind: "message", T: () => WindowMethod },
            { no: 4, name: "aggregation", kind: "message", T: () => AggregationMethod }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.TableNodeColumn
 */
export const TableNodeColumn = new TableNodeColumn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TableNodeColumns$Type extends MessageType<TableNodeColumns> {
    constructor() {
        super("dashboard.v1.TableNodeColumns", [
            { no: 1, name: "columns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TableNodeColumn }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.TableNodeColumns
 */
export const TableNodeColumns = new TableNodeColumns$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TableNode$Type extends MessageType<TableNode> {
    constructor() {
        super("dashboard.v1.TableNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "capture_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "columns", kind: "message", oneof: "displayMethod", T: () => TableNodeColumns },
            { no: 6, name: "custom_query", kind: "message", oneof: "displayMethod", T: () => MethodCustomQuery }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.TableNode
 */
export const TableNode = new TableNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DashboardNode$Type extends MessageType<DashboardNode> {
    constructor() {
        super("dashboard.v1.DashboardNode", [
            { no: 1, name: "node_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "split", kind: "message", oneof: "node", T: () => SplitNode },
            { no: 3, name: "stat", kind: "message", oneof: "node", T: () => StatNode },
            { no: 4, name: "time_series", kind: "message", oneof: "node", T: () => TimeSeriesNode },
            { no: 5, name: "gps", kind: "message", oneof: "node", T: () => GPSNode },
            { no: 6, name: "table", kind: "message", oneof: "node", T: () => TableNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.DashboardNode
 */
export const DashboardNode = new DashboardNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Dashboard$Type extends MessageType<Dashboard> {
    constructor() {
        super("dashboard.v1.Dashboard", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "layout_root", kind: "message", T: () => DashboardNode },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dashboard.v1.Dashboard
 */
export const Dashboard = new Dashboard$Type();
/**
 * @generated ServiceType for protobuf service dashboard.v1.DashboardService
 */
export const DashboardService = new ServiceType("dashboard.v1.DashboardService", [
    { name: "CreateDashboard", options: {}, I: CreateDashboardRequest, O: CreateDashboardResponse },
    { name: "GetDashboard", options: {}, I: GetDashboardRequest, O: GetDashboardResponse },
    { name: "ListDashboards", options: {}, I: ListDashboardsRequest, O: ListDashboardsResponse },
    { name: "DuplicateDashboard", options: {}, I: DuplicateDashboardRequest, O: DuplicateDashboardResponse },
    { name: "DeleteDashboard", options: {}, I: DeleteDashboardRequest, O: DeleteDashboardResponse },
    { name: "UpdateDashboardLayout", options: {}, I: UpdateDashboardLayoutRequest, O: UpdateDashboardLayoutResponse },
    { name: "UpdateDashboardName", options: {}, I: UpdateDashboardNameRequest, O: UpdateDashboardNameResponse }
]);
